export const GET_ROSTER = 'VST.Bridge.Roster.get';
export const GET_SESSION = 'VST.Bridge.Session.get';
export const LOG_IN = 'VST.Bridge.Session.login';
export const LOG_OUT = 'VST.Bridge.Session.logout';
export const ACTIVATE_ASSET = 'VST.BridgeAsset.activate';
export const RESET_USER = 'VST.Bridge.User.reset';
export const UPDATE_USER = 'VST.Bridge.User.update';
export const CREATE_USER = 'VST.Bridge.User.create';
export const GET_USER = 'VST.Bridge.Users.get';
export const LIST_GROUPS = 'VST.Bridge.Groups.list';
export const GET_GROUP = 'VST.Bridge.Groups.get';
export const CREATE_ADOPTION = 'VST.Bridge.Adoptions.create';
export const DELETE_ADOPTION = 'VST.Bridge.Adoptions.delete';
export const LIST_ADOPTIONS = 'VST.Bridge.Adoptions.list';
export const GET_ADOPTION = 'VST.Bridge.Adoptions.get';
export const GET_TAXONOMIES = 'VST.Bridge.Taxonomies.get';
export const LIST_ASSETS_MULTI = 'VST.Bridge.Assets.lists';

// When used with redux, the following are not used directly in favor of the remapped versions
// that provide some additional use context
export const LIST_ASSETS = 'VST.Bridge.Assets.list';
export const UPDATE_ASSETS = 'VST.Bridge.Assets.update';
export const UPDATE_ADOPTION = 'VST.Bridge.Adoptions.update';
export const LIST_USERS = 'VST.Bridge.Users.list';



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/bridge-methods.js